module.exports = __webpack_public_path__ + "static/media/plaque_or_2023.bb521a33.png";